import React, { useState } from 'react';

import './styles.css';
import 'react-toastify/dist/ReactToastify.css';

import P from 'prop-types';
import { Button } from '../Button';
import { Modal } from '../Modal';
import { toast } from 'react-toastify';
import API from '../../utils/api/office.instance';

export const CadastroClienteRodape = ({ param, handleBodyModal }) => {
  const { modalSMS, setModalSMS } = useState();
  const showHideModalSMS = () => {
    setModalSMS(modalSMS == 'none' ? 'block' : 'none');
  };
  let obj = {};
  const obterDadosFormulario = () => {
    let termosAceito = document.getElementsByName('termoAceite')[0].checked;
    let nome = String(document.getElementsByName('nome')[0].value);
    let email = document.getElementsByName('email')[0].value;
    let senha = document.getElementsByName('senha')[0].value;
    let telefone = String(document.getElementsByName('telefone')[0].value);
    let idxString = 0;

    //Tratando Nome e sobrenome
    idxString = nome.indexOf(' ');
    let nome_completo = nome.trim();
    let sobrnome = idxString == -1 ? '' : nome.slice(idxString).trim();
    nome = nome.slice(0, idxString).trim();

    //Tratando telefone e DDD
    idxString = telefone.indexOf(' ');
    let ddd = telefone.slice(0, idxString);
    telefone = telefone.slice(idxString).trim();

    obj = {
      nome: nome,
      sobrenome: sobrnome,
      nome_completo: nome_completo,
      termoAceite: termosAceito,
      email: email,
      senha: senha,
      telefone_ddd: ddd,
      telefone: telefone,
      empresa_fantasia: param.Empresa.fantasia,
      empresa_razao: param.Empresa.razao,
      data_aniversario: '2011-01-01',
      cpf: '',
      sexo: 'Masculino',
      idloja: param.Empresa.codigo_sistema,
    };

    return obj;
  };

  const handleCadastro = () => {
    let obj = obterDadosFormulario();
    API.post('/office/AutoAtendimento/Cadastro', obj)
      .then((response) => {
        //Chama modal SMS
        if (response.data.Retorno) {
          if (response.data.Retorno.status == 1) toast.error(response.data.Retorno.msg, { containerId: 'modalToast' });
          return;
        }

        //handleBodyModal('SMS', 'Autentique sua conta', response.data.Usuario);

        showHideModalSMS();

        //toast.success('Bem vindo ' + response.data.Usuario.nome + '!');
      })
      .catch((err) => {
        toast.error('Erro interno do Servidor! ' + err, { containerId: 'modalToast' });
      });
  };
  return (
    <div>
      <Button text="Registrar Agora!" className={'btnGradient btn-width-full'} onClick={handleCadastro} />
      <div className={'clearfix-checkbox'}></div>
      Já possui cadastro?{' '}
      <a href="#" onClick={() => handleBodyModal('LOGIN', 'Login')} style={{ color: '#e54750', cursor: 'pointer' }}>
        Login
      </a>
      {modalSMS === 'block' && (
        <Modal
          title="Autentique sua conta"
          isFooter={false}
          visibility={modalSMS}
          param={obj}
          page="SMS"
          btnOnClickClose={showHideModalSMS}
          customPosition="modal-position-bottom"
        />
      )}
    </div>
  );
};

CadastroClienteRodape.propTypes = {
  handleBodyModal: P.func,
  param: P.object,
};
